import CustomButton from "../../components/CustomButton";

import CONSTANTS from "../../utils/constants/CONSTANTS";
import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import "./index.scss";

const InpersonImageGroup = ({ phoneOne, phoneTwo, largeImage }) => {
  const handleRedirect = () => {
    window.open(CONSTANTS.baseUrl, "_blank");
    eventTrack("Redirection To Web Portal", "From sign up button in workouts section", "Redirection");
    eventTrackGA4("Redirection To Web Portal", "From sign up button in workouts section", "Redirection");
  };
  return (
    <div className="workout-group">
      <div className="phone-images">
        <div className="phone-odd">
          <img src={phoneOne} className="image-odd" alt="Phone image" />
        </div>
        <div className="btn-container"></div>
        <div className="phone-even phone-two">
          <img src={phoneTwo} className="image-even" alt="Phone image" />
          <div className="btn">
            <CustomButton type={CONSTANTS.WHITE_TYPE} handleClick={handleRedirect}>
              Signup
            </CustomButton>
          </div>
        </div>
        <div className="phone-odd">
          <img src={largeImage} className="large-img" alt="Phone image" />
        </div>
      </div>
    </div>
  );
};
export default InpersonImageGroup;
